const ConformanceLevels = {
	'WCAG-A': 'A',
	'WCAG-AA': 'AA',
	'WCAG-AAA': 'AAA',
	UNSPECIFIED: 'Unspecified'
};

export { ConformanceLevels };
